type ContextLostTarget = Pick<
    EventTarget,
    'addEventListener' | 'removeEventListener'
>;

// A lost context is usually recoverable: browsers cap how many live WebGL
// contexts a page may hold and will evict the least-recently-used one to
// make room for a new one, which is routine, not a real "WebGL is broken"
// failure. Calling preventDefault() signals the browser to attempt recovery.
export const attachWebGLContextLostHandler = (
    canvas: ContextLostTarget,
    onLost: () => void
): (() => void) => {
    const handleContextLost = (event: Event) => {
        event.preventDefault();
        onLost();
    };

    canvas.addEventListener('webglcontextlost', handleContextLost);

    return () => {
        canvas.removeEventListener('webglcontextlost', handleContextLost);
    };
};
